import React from "react"
import CloseModal from "../CloseModal"
import { useNavigate } from "react-router-dom"
import { UserCtx } from "../../context/userContext"
import { useContext } from "react"
import { Button } from "../ui/button"

interface Props {
  showPopup: boolean
  setShowPopup: React.Dispatch<React.SetStateAction<boolean>>
  redirectUrl: string
  promoCode: string
}

const PromoCodeSuccessPopUp: React.FC<Props> = ({
  showPopup,
  setShowPopup,
  redirectUrl,
  promoCode,
}) => {
  const { user } = useContext(UserCtx)
  const navigate = useNavigate()

  if (!showPopup) return null

  const handleNavigateToSubx = () => {
    setShowPopup(false)
    navigate(`/${user.activeProfile}/subscription/current`)
  }

  const renderMessage = () => {
    if (promoCode === "ZOEELIFEFIRST50" || promoCode === "ZOEELIFEPOST50") {
      return (
        <>
          <h5 className="text-2xl font-bold mb-4">
            🎉 You're locked in for 50% OFF for life!
          </h5>
          <p className="text-muted-foreground text-[#45474a] mb-4">
            You made it—one of the first 50 coaches to claim this exclusive
            deal. That's over $245 saved every year—FOREVER!
          </p>
          <p className="text-muted-foreground text-[#45474a] mb-6">
            This isn't just a discount. It's a launchpad. 🚀
          </p>
        </>
      )
    } else if (promoCode === "ZOEELIFEPOST50") {
      return (
        <>
          <h5 className="text-2xl font-bold mb-4">
            ⚡ We sold out in record time… but you're in!
          </h5>
          <p className="text-muted-foreground text-[#45474a] mb-4">
            You weren't in the first 50—but because of overwhelming demand,
            we've reopened the 50% OFF for life deal for 24 more hours.
          </p>
          <p className="text-muted-foreground text-[#45474a] mb-4">
            And guess what? Your purchase qualifies. 🎉
          </p>
          <p className="text-muted-foreground text-[#45474a] mb-6">
            You just locked in a deal we almost closed for good. Let's go. 💥
          </p>
        </>
      )
    }
    return null
  }

  return (
    <div className="zoee-backdrop-filter credentials fixed left-0 top-0 z-[1000] flex h-screen w-screen items-center justify-center">
      <div className="main-shadow fixed left-1/2 flex h-auto max-h-[85vh] w-[90%] max-w-[504px] -translate-x-1/2 flex-col items-center gap-4 overflow-y-auto rounded-xl bg-white px-4 py-10 md:px-10">
        <CloseModal
          callback={handleNavigateToSubx}
          styling="absolute top-6 right-8"
        />

        <div className="text-center">
          {renderMessage()}
          <Button onClick={handleNavigateToSubx} size="lg">
            Go to My Subscription
          </Button>
        </div>
      </div>
    </div>
  )
}

export default PromoCodeSuccessPopUp
